import { classHotTagType } from 'common/map'

export default {
  props: {
    // 课程列表
    coursesList: {
      default: () => [],
      type: Array,
    },

    // 加载中
    loading: {
      default: false,
      type: Boolean,
    },

    // 是否加载数据完成
    loadend: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      langContext: this.$t('featureComponents.CoursesResults'),
    }
  },

  methods: {
    // 获取班级热度标签类型
    getClassHotTagType(store, sellStore, remainSellTime) {
      return classHotTagType(store, sellStore, remainSellTime)
    },

    // 加载更多事件
    handleLoadMore(type = 'normal') {
      this.$emit('load-more', type)
    },
  },
}
